"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SliderItemsController {
    constructor(items, currentItemId) {
        this.items = items;
        this.currentItemId = currentItemId;
    }
    get currentItem() {
        const currentItem = this.items.find((item) => item.id === this.currentItemId);
        return currentItem;
    }
    get sliderItems() {
        return this.items;
    }
}
exports.default = SliderItemsController;
